export const getOwnUrl = () => {
  if (document.domain === "localhost") {
    return "http://localhost:3000";
  } else {
    return "https://creator.6cuts.com";
  }
};
